import { Component, Input } from '@angular/core';
import {FormsModule} from '@angular/forms';
import { dashboard_messages } from '../../../providers/static-data';
import { CommonModule, DatePipe } from '@angular/common';

type ChatType = 'messages' | 'chats' | 'queries';


@Component({
  selector: 'app-chat-box-card',
  standalone: true,
  imports: [FormsModule,CommonModule ],
  templateUrl: './chat-box-card.component.html',
  styleUrl: './chat-box-card.component.scss',
  providers: [DatePipe]
})
export class ChatBoxCardComponent {
  @Input() filter: boolean = false;

  chatBoxType : ChatType = 'messages';

  messages = dashboard_messages

}
